import {UserOrdersHistory} from '../../models';
import {makeAsyncReducer, StateAsyncProperty} from '../../redux-toolbelt';

import {fetchOrdersHistoryIfNeeded} from './ordersHistoryActions';

export type OrdersHistoryState = StateAsyncProperty<UserOrdersHistory>;

export default makeAsyncReducer<OrdersHistoryState>(fetchOrdersHistoryIfNeeded);
